import {Jwt} from './resources'
import LocalStorage from './session-storage'
import firebase from 'firebase'

export default {
    get token () {
        return LocalStorage.getObject('token')
    },
    set token (value) {
        LocalStorage.setObject('token', value)
    },
    accessToken (email, password) {
        return Jwt.accessToken(email, password).then((response) => {
            this.token = response.data.token
            return response
        })
    },
    logout () {
        LocalStorage.clear()
        firebase.auth().signOut()        
    }
}



// WEBPACK FOOTER //
// ./src/services/jwt-token.js